import jQuery from "jquery";
const $ = jQuery;

const minPerSlide = 4
function initCarousels(container)
{
    const items = $('.carousel-multi > .carousel-inner > .carousel-item', container);

    $(items).each(function( index ) {
        const element = this;
        let next = element.nextElementSibling
        for (var i=1; i<minPerSlide; i++) {
            if (!next) {
                // wrap carousel by using first child
                next = items[0]
            }
            let cloneChild = next.cloneNode(true)
            element.appendChild(cloneChild.children[0])
            next = next.nextElementSibling
        }
    });
}


$(document).ready(function () {
    initCarousels($('body'));
    document.body.addEventListener('htmx:load', function(evt) {
        initCarousels(evt.detail.elt);
    });
});